import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import LeftNav from './leftNav/container';
import MainFeed from './mainFeed/container';
import { Paper } from 'material-ui';
import {
  initialNewsfeedLoad as initialNewsfeedLoadAction,
  loadMore as loadMoreAction,
  changeNewsfeedFilter as changeNewsfeedFilterAction,
  getHashtags as getHashtagsAction,
  updateProps as updatePropsAction,
} from '../../stores/newsfeed/actions';
import { getMetadata as getMetadataAction } from '../../stores/newsfeed/metaData/metaData-actions';
import R from 'ramda';

import ImproveFeedContainer from './improveFeed/improveFeedContainer';

const propTypes = {
  initialNewsfeedLoad: PropTypes.func,
  loadMore: PropTypes.func,
  changeNewsfeedFilter: PropTypes.func,
  getHashtags: PropTypes.func,
  getMetadata: PropTypes.func,
  updateProps: PropTypes.func,
  user: PropTypes.object,
  newsfeed: PropTypes.array,
  ownerMetaData: PropTypes.object,
  isAdmin: PropTypes.bool,
};

class NewsFeed extends Component {

  componentWillMount() {
    const { getHashtags, initialNewsfeedLoad, newsfeed, getMetadata } = this.props;
    getHashtags();
    getMetadata();
    if (R.isEmpty(newsfeed)) initialNewsfeedLoad();
    this.props.updateProps({
      selectedLeftNav: 'News Feed',
      filterType: '',
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  componentWillUnmount() {
    this.props.updateProps({ newsfeed: [] });
  }

  render() {
    const { ownerMetaData, isAdmin } = this.props;
    return (
      <div className="l-app-content">
        <div className="newsfeed-container">
          <div className="left-nav-mobile-breakpoint">
            <LeftNav changeNewsfeedFilter={this.props.changeNewsfeedFilter} isAdmin={isAdmin}/>
            {
              ownerMetaData.gotMetaDataCount && isAdmin && (
                <Paper style={{ padding: '3%', marginBottom: '24px' }}>
                  <br/>
                  <div>This data is for TC Admins only</div>
                  <br/>
                  {
                    ['postsCount', 'followsCount', 'followersCount'].map(key => (
                      <div
                        key={key}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px', cursor: 'pointer' }}
                        onClick={() => this.context.router.push(`/newsfeed/meta/${R.replace('Count', '', key)}`)}
                      >
                        <a>{R.replace('Count', '', key).toUpperCase()}</a>
                        <a>{ownerMetaData[key]}</a>
                      </div>
                    ))
                  }
                </Paper>
              )
            }
          </div>
          <div className="main-feed">
            <MainFeed loadMore={this.props.loadMore} changeNewsfeedFilter={this.props.changeNewsfeedFilter} />
          </div>
          <div className="right-side-mobile-breakpoint">
            <ImproveFeedContainer {...ownerMetaData} />
          </div>
        </div>
      </div>
    );
  }
}

NewsFeed.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  initialNewsfeedLoad: (...args) => dispatch(initialNewsfeedLoadAction(...args)),
  loadMore: (...args) => dispatch(loadMoreAction(...args)),
  changeNewsfeedFilter: (...args) => dispatch(changeNewsfeedFilterAction(...args)),
  getHashtags: (...args) => dispatch(getHashtagsAction(...args)),
  getMetadata: (...args) => dispatch(getMetadataAction(...args)),
  updateProps: (...args) => dispatch(updatePropsAction(...args)),
});

const mapStateToProps = ({ newsfeed, user, newsfeedMetaData }) => ({
  newsfeed: newsfeed.get('newsfeed').toJS(),
  ownerMetaData: newsfeedMetaData.toJS(),
  isAdmin: user.get('isAnAdmin'),
});

NewsFeed.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsFeed);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/newsfeed-container.jsx